import { MARQUEE_ITEMS } from "@/lib/site";

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex items-center shrink-0">
    {MARQUEE_ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.25em] px-6 whitespace-nowrap">
          {item}
        </span>
        <span className="text-gold text-[10px]" aria-hidden="true">
          ✦
        </span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="marquee-band"
    className="marquee relative bg-ink text-paper py-5 -rotate-1 scale-[1.02] overflow-hidden shadow-lg shadow-ink/10"
  >
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);
